
import Checkbok from '../checkbox/index.jsx'
import CheckboxItem from '../checkbox/item.jsx'
import React from 'react'
import UploadPictures from '../uploadPictures/index.jsx'
import { Input } from 'antd'
import Slider from '../slider/index.jsx'

export default function Card4(props) {
  return <React.Fragment>
    <div className='suspensionSide_item'>
      <span className='item_title'>关注方式</span>
      <div className='item_mainTransverse'>
        <Checkbok list={props.ifon.attentionMode} change={(list) => {
          props.ifon.attentionMode = list
          props.mySetIfon(props.ifon)
        }}>
          <CheckboxItem id={1}>复制微信</CheckboxItem>
          <CheckboxItem id={2}>分享朋友圈</CheckboxItem>
        </Checkbok>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>公众号链接</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Input value={props.ifon.officialAccountLink} placeholder='请输入公众号链接' onChange={(e) => {
            props.ifon.officialAccountLink = e.target.value
            props.mySetIfon(props.ifon)
          }} />
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>账号头像</span>
      <div className='item_mainTransverse'>
        {!props.ifon.cardStyle.card4.backImage.src ? null : <ul className='imgBox'>
          <li className='boxImg'>
            <img className='boxImg_img' src={props.ifon.cardStyle.card4.backImage.src} />
            <i className='boxImg_icon' onClick={() => {
              props.ifon.cardStyle.card4.backImage = {}
              props.mySetIfon(props.ifon)
            }}></i>
          </li>
        </ul>}

        {props.ifon.cardStyle.card4.backImage.src ? null : <div className='item'>
          <UploadPictures change={(e) => {
            const src = window.URL.createObjectURL(e.file)
            props.ifon.cardStyle.card4.backImage = { src, file: e.file }
            props.mySetIfon(props.ifon)
          }}></UploadPictures>
          <span className='item_tips'>图片要求：png/jpg/jpeg/gif, 500*500, 小于3M。</span>
        </div>}

      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>布局</span>
      <div className='item_mainTransverse'>
        <ul className='ulBox' onClick={(e) => {
          const text = e.target.dataset.index
          if (text) {
            props.ifon.layout = parseFloat(text)
            props.mySetIfon(props.ifon)
          }
        }}>
          <li className={`BoxLi ${props.ifon.layout === 0}`} data-index={0}>居左</li>
          <li className={`BoxLi ${props.ifon.layout === 1}`} data-index={1}>居中</li>
          <li className={`BoxLi ${props.ifon.layout === 2}`} data-index={2}>居右</li>
        </ul>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>边距</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingTop} change={(value) => {
            props.ifon.paddingTop = value
            props.mySetIfon(props.ifon)
          }}>上</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingBottom} change={(value) => {
            props.ifon.paddingBottom = value
            props.mySetIfon(props.ifon)
          }}>下</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingLeft} change={(value) => {
            props.ifon.paddingLeft = value
            props.mySetIfon(props.ifon)
          }}>左</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingRight} change={(value) => {
            props.ifon.paddingRight = value
            props.mySetIfon(props.ifon)
          }}>右</Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>固定悬浮</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.isSuspension ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.isSuspension = !props.ifon.isSuspension
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>与底部距离</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider defaultValue={props.ifon.bottomDistance} change={(value) => {
            props.ifon.bottomDistance = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>页尾留白</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider maxValue={200} defaultValue={props.ifon.message} change={(value) => {
            props.ifon.message = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>引导图片</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.isGuide ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.isGuide = !props.ifon.isGuide
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>引导悬浮</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.floatingLayer ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.floatingLayer = !props.ifon.floatingLayer
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
        <span className='switch_tips'>点击加粉按钮后显示引导弹层，然后再跳转至微信；若落地页页面中已含有引导信息，可关闭该浮层。</span>
      </div>
    </div>
  </React.Fragment>
}
